<template>
   <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>质安管理</el-breadcrumb-item>
                <el-breadcrumb-item>质安检查</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <!-- <div class="main-left">
                <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='projectId' highlight-current default-expand-all></el-tree>
            </div> -->
            <div class="main-table qsList">
                <i class="el-icon-s-tools" @click="addConfig" style="position: absolute;right: 10px;top: 8px;z-index: 10;font-size: 25px;cursor: pointer;color:#409EFF;"></i>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="公司检查" name="first">
                        <div class="build-bar" >
                            <p :class="(curId==0?'on':'')" @click="selectIndex(0)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                累计检查数量：{{num.allCount}}
                            </p>
                            <p :class="(curId==1?'on':'')" @click="selectIndex(1)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                本月检查：{{num.monthCount}}
                            </p>
                            <p :class="(curId==2?'on':'')" @click="selectIndex(2)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                本周检查：{{num.weekCount}}
                            </p>
                            <p :class="(curId==3?'on':'')" @click="selectIndex(3)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;color:#06A511;margin-left:1vh;cursor: pointer;">
                               检查已处理：{{num.disposeCount}}
                            </p>
                            <p :class="(curId==4?'on':'')" @click="selectIndex(4)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;color:#FF0000;margin-left:1vh;cursor: pointer;">
                               检查未处理：{{num.unDisposeCount}}
                            </p>
                        </div>
                        <div class="build-table">
                            <div class="table-item" v-for="(item,index) in entQsList" :key="index">
                                <div class="item-l">
                                    <img :src="item.pic" style="width:100%;height:100%;" />
                                </div>
                                <div class="item-mid">
                                    <p>检查事项：</p>
                                    <p class="line2" style="height:6vh;" :title="item.description">{{item.description}}</p>
                                    <p  >问题性质:
                                      <span :class="(item.priority==2?'cur':'')">{{item.priorityName||'无'}}</span>
                                    </p>
                                    <p>检查人：{{item.reportName}}</p>
                                    <p>检查时间：{{item.happenDate}}</p>
                                </div>
                                <div class="item-mid">
                                    <p>检查结果：<span v-if="item.checkResult=='无'||item.checkStatus=='已处理'" style="color:#1ed76d;">{{'合格'||'--'}}</span><span v-else style="color:red;">{{'待整改'||'--'}}</span></p>
                                    <p>处理人：{{item.handlerName ||'--'}}</p>
                                    <p>处理状态：{{item.checkStatus ||'--'}}</p>
                                    <p>确认人：{{item.affirm || '--'}}</p>
                                    <p>确认状态：{{item.affirmStatus || '--'}}</p>
                                    <p>地址:{{item.address || '--'}}</p>
                                </div>
                                <div class="item-l">
                                  <img  v-if="item.affirmPicUrls" :src="item.affirmpic" style="width:100%;height:100%;" />
                                </div>
                                <div class="item-r">
                                    <el-button type="text" @click="toDetail(item)">详情</el-button>
                                    <el-button type="text" @click="toDownFile(item)" style="color:#67C23A;">导出</el-button>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[5, 10, 20, 50]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalItems"
                        ></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="项目检查" name="second">
                        <div class="build-bar">
                            <p :class="(curId==0?'on':'')" @click="selectIndex(0)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                累计检查数量：{{num.allCount}}
                            </p>
                            <p :class="(curId==1?'on':'')" @click="selectIndex(1)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                本月检查：{{num.monthCount}}
                            </p>
                            <p :class="(curId==2?'on':'')" @click="selectIndex(2)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;margin-left:1vh;cursor: pointer;">
                                本周检查：{{num.weekCount}}
                            </p>
                            <p :class="(curId==3?'on':'')" @click="selectIndex(3)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;color:#06A511;margin-left:1vh;cursor: pointer;">
                                检查已处理：{{num.disposeCount}}
                            </p>
                            <p :class="(curId==4?'on':'')" @click="selectIndex(4)" style="height:100%;padding:0 1vw;display:flex;align-content: center;align-items: center;color:#FF0000;margin-left:1vh;cursor: pointer;">
                                 检查未处理：{{num.unDisposeCount}}
                            </p>
                        </div>
                        <div class="build-table">
                            <div class="table-item" v-for="(item,index) in proQsList" :key="index">
                                <div class="item-l">
                                    <img :src="item.pic" style="width:100%;height:100%;" />
                                </div>
                                <div class="item-mid">
                                    <p>检查事项：</p>
                                    <p class="line2" style="height:6vh;" :title="item.description">{{item.description}}</p>
                                    <p  >问题性质:
                                      <span :class="(item.priority==2?'cur':'')">{{item.priorityName||'无'}}</span>
                                    </p>
                                    <p>检查人：{{item.reportName}}</p>
                                    <p>检查时间：{{item.happenDate}}</p>
                                </div>
                                <div class="item-mid">
                                    <p>检查结果：
                                        <span v-if="item.checkResult=='无'" style="color:#1ed76d;">{{'合格'||'--'}}</span>
                                        <span v-else-if="item.checkStatus=='已处理'" style="color:#E6A23C">{{item.checkResult}}</span>
                                        <span v-else style="color:red;">{{'待整改'||'--'}}</span>
                                    </p>
                                    <p>责任人：{{item.handlerName ||'--'}}</p>
                                    <p>处理状态：{{item.checkStatus ||'--'}}</p>
                                    <p>确认人：{{item.affirm || '--'}}</p>
                                    <p>确认状态：{{item.affirmStatus || '--'}}</p>
                                    <p>地址:{{item.address || '--'}}</p>
                                </div>
                                <div class="item-l" >
                                  <img  v-if="item.affirmPicUrls" :src="item.affirmpic" style="width:100%;height:100%;" />
                                </div>
                                <div class="item-r">
                                    <el-button type="text" @click="toDetail(item)">详情</el-button>
                                    <el-button type="text" @click="toDownFile(item)" style="color:#67C23A;">导出</el-button>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                            @size-change="handleSizeChange1"
                            @current-change="handleCurrentChange1"
                            :current-page="currentPage1"
                            :page-sizes="[5, 10, 20, 50]"
                            :page-size="pageSize1"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalItems1"
                        ></el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 预警配置 -->
        <el-dialog width="500px" title="预警配置" :visible.sync="warnVis" append-to-body>
            <el-form
            :model="set"
            ref="set"
            label-width="160px"
            label-position="right"
            >
                <el-form-item v-for="(item,index) in setList" :key="index" :label="item.priorityName+'：'">
                    <el-select v-model="item.limitDate" placeholder="请选择时间">
                    <el-option
                        v-for="item in dateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.value">
                    </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="warnVis = false">取 消</el-button>
            <el-button type="primary" @click="configInfo()">确 定</el-button>
            </div>
        </el-dialog>
   </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
    data(){
        return{
            tabIndex:'',
            groupId:'',
            dataTree:[],//左侧班组树形结构
            defaultProps:{
                children: 'list',
                 label: 'name'
            },
            search: {//查询
                
            },
            head:{
                timeType:3,//时间类型  1：日    2：周    3：月
                time1:util.myTime.getCurTime(),
                time2:util.myTime.getWeekDay(-1),
                time3:util.myTime.getCurMonth(),
                startDate:'',
                endDate:'',
                flag:'5',
                type:'',
            },
            head1:{
                timeType:3,//时间类型  1：日    2：周    3：月
                time1:util.myTime.getCurTime(),
                time2:util.myTime.getWeekDay(-1),
                time3:util.myTime.getCurMonth(),
                startDate:'',
                endDate:'',
                flag:'5', 
                type:'',
            },
            num:{
                allCount: 0,
                disposeCount: 0,
                monthCount: 0,
                unDisposeCount: 0,
                weekCount: 0,
            },
            activeName:'first',
            projectId:'',
            //企业分页
            currentPage:1,
            pageSize:10,
            totalItems:0,
            //项目分页
            currentPage1:1,
            pageSize1:10,
            totalItems1:0,
            entQsList:[],//企业检查
            proQsList:[],//项目检查
            // types:[
            //     {id:'1',value:'1',label:'无'},
            //     {id:'2',value:'2',label:'有'}
            // ],
            curId:0,
            types:[],
            //弹出框
            warnVis:false,
            set:{
                projectId:'',
                priorityTyep:'',
                limitDate:'',
            },
            setList:[],
            dateList:[
                {id:'0',name:'12小时',value:'12'},
                {id:'1',name:'24小时',value:'24'},
                {id:'2',name:'48小时',value:'48'},
                {id:'3',name:'72小时',value:'72'},
            ],
            
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.projectId = this.groupId
        this.getDictByType()
        this.getData()
        this.getNum()
    },
    methods:{

        //公司分页
        handleSizeChange(val){
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.currentChangePage();
        },
        currentChangePage() {
            this.getData();
        },
        //获取公司检查
        getData(){
            var dispose = 3
            var type = ''
            if(this.curId==0){
                this.head.startDate = '';
                this.head.endDate = ''; 
                dispose = 3
            }else if(this.curId==2){
                // console.log(this.head.time2)
                // this.head.startDate = this.head.time2;
                // this.head.endDate = util.myTime.getWeekDay(5,this.head.time2);
                var obj = util.myTime.getWeekDateWai()
                this.head1.startDate =  obj.start;
                this.head1.endDate = obj.end;
                dispose = 3
            }else if(this.curId==1){
                this.head.startDate = this.head.time3+'-01';
                var day = new Date(parseInt(this.head.time3.split('-')[0]),parseInt(this.head.time3.split('-')[1]),0).getDate();
                this.head.endDate = this.head.time3+'-'+day;
                dispose = 3
            }else if(this.curId==3){
                this.head.startDate = '';
                this.head.endDate = '';
                type = 2
                dispose = 2
            }else if(this.curId==4){
                this.head.startDate = '';
                this.head.endDate = '';
                dispose = 1
                type = 2
            }
            var that = this
            myHttp.selectQsListByProjectIdPage({
                projectId:this.projectId,
                starTime:this.head.startDate,
                endTime:this.head.endDate,
                form:'2',
                type:type,
                dispose:dispose,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp) {
                if(resp.data.code=='200'){
                    var list = resp.data.data.qsList.list||[]
                    for(var i=0;i<list.length;i++){
                        for(var j=0;j<that.types.length;j++){
                          if(list[i].priority==that.types[j].value){
                            list[i].priorityName =that.types[j].label
                          }
                        }
                        list[i].pic = list[i].picUrls && list[i].picUrls!=''?base.httpCtx+(list[i].picUrls.split(',')[0]):require('../../assets/image/project.png')
                        list[i].affirmpic = list[i].affirmPicUrls && list[i].affirmPicUrls!=''?base.httpCtx+(list[i].affirmPicUrls.split(',')[0]):require('../../assets/image/zanwutupian.png')
                    }
                    that.totalItems = resp.data.data.qsList.total||0
                    that.entQsList = list
                }
            })
        },
        //获取数量
        getNum(){
            var that = this
            var form = '2'
            if(this.tabIndex == 1){
                 form = '1'
            }
            myHttp.selectQsCountByProjectId({
                projectId:this.projectId,
                form:form
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    if(data){
                        that.num = data
                    }
                }
            })
        },
        //时间类型修改(公司检查)
        changType(index){
            if(this.head.timeType != index){
                this.head.timeType = index;
                this.getData();
            }
        },
        //时间改变(公司检查)
        timeChange(){
            this.getData();
        },

        //切换累计数量，本月检查，本周检查，
        selectIndex(index){
            if(this.curId!=index){
                this.curId = index
                if(this.tabIndex==0){
                    this.getData()
                }else{
                    this.getData1()
                }
            }
        },

        //项目分页
        handleSizeChange1(val){
            this.pageSize1 = val
            this.handleCurrentChange1(this.currentPage)
        },
        handleCurrentChange1(val){
            this.currentPage1 = val
            this.currentChangePage1();
        },
        currentChangePage1() {
            this.getData1();
        },
        //获取项目检查
        getData1(){
            var dispose = 3
            var type = ''
            if(this.curId==0){
                this.head1.startDate = '';
                this.head1.endDate = '';
                dispose = 3
            }else if(this.curId==2){
                // this.head1.startDate = this.head1.time2;
                // this.head1.endDate = util.myTime.getWeekDay(5,this.head1.time2);
                var obj = util.myTime.getWeekDateWai()
                this.head1.startDate =  obj.start;
                this.head1.endDate = obj.end;
                dispose = 3
            }else if(this.curId==1){
                this.head1.startDate = this.head1.time3+'-01';
                var day = new Date(parseInt(this.head1.time3.split('-')[0]),parseInt(this.head1.time3.split('-')[1]),0).getDate();
                this.head1.endDate = this.head1.time3+'-'+day;
                dispose = 3
            }else if(this.curId==3){
                this.head1.startDate = '';
                this.head1.endDate = '';
                dispose = 2
                type = 2
            }else if(this.curId==4){
                this.head1.startDate = '';
                this.head1.endDate = '';
                dispose = 1
                type = 2
            }
            var that = this
            myHttp.selectQsListByProjectIdPage({
                projectId:this.projectId,
                starTime:this.head1.startDate,
                endTime:this.head1.endDate,
                form:'1',
                type:type,
                dispose:dispose,
                pageNum:this.currentPage1,
                pageSize:this.pageSize1
            }).then(function(resp) {
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.qsList.list||[]
                    for(var i=0;i<list.length;i++){
                      for(var j=0;j<that.types.length;j++){
                          if(list[i].priority==that.types[j].value){
                            list[i].priorityName =that.types[j].label
                          }
                        }
                        list[i].pic = list[i].picUrls && list[i].picUrls!=''?base.httpCtx+(list[i].picUrls.split(',')[0]):require('../../assets/image/project.png')
                        list[i].affirmpic = list[i].affirmPicUrls && list[i].affirmPicUrls!=''?base.httpCtx+(list[i].affirmPicUrls.split(',')[0]):require('../../assets/image/zanwutupian.png')
                      }
                    that.totalItems1 = resp.data.data.qsList.total||0
                    that.proQsList = list
                }
            })
        },
        //时间类型修改(项目检查)
        changType1(index){
            if(this.head1.timeType != index){
                this.head1.timeType = index;
                this.getData1();
            }
        },
        //时间改变(项目检查)
        timeChange1(){
            this.getData1();
        },

        //切换
        handleClick(e){
            if(this.tabIndex!=e.index){
                this.tabIndex = e.index
                this.curId = 0
                if(this.tabIndex == 0 ){
                    this.currentPage = 1
                    this.getData()
                }else{
                    this.currentPage1 = 1
                    this.getData1()
                }
                this.getNum()
            }
            

        },


        /**
         * 详情
         */
        toDetail(row){
            console.log(row)
            // handle:是否从我的里面进去
            this.$router.push({ name: 'qsDetail', params: { id: row.qsId ,type:row.type,handle:'1'} })
        },
        /**
         * 下载
         */
        toDownFile(row){
            var token = util.session.get('token')
            window.open(
                myHttp.exportQsInfo +
                '?id=' +
                row.qsId +
                '&accessToken=' +
                token
            )
        },
         // 获取问题列表
      getDictByType(){
            var that = this
            myHttp
                .getDictByType({
                type: 'qs_priority'
                })
                .then(function(resp) {
                if (resp.data.code == '200') {
                    that.types = resp.data.data.dictList
                    var list = resp.data.data.dictList
                    that.setList = []
                    for(var i=0;i<list.length;i++){
                        var obj = {
                            projectId:that.groupId,
                            priorityTyep:list[i].value,
                            priorityName:list[i].label,
                            limitDate:'',
                        }
                        that.setList.push(obj)
                    }
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        },
        //展示配置弹出框
        addConfig(){
            this.warnVis = true
            var that = this
            myHttp.selectQsConfigurationByProjectId({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    if(list.length>0){
                        for(var i=0;i<list.length;i++){
                            that.setConfig(list[i])
                        }
                    }else{
                        for(var i=0;i<that.setList;i++){
                             that.setList[i].limitDate = ''
                        }
                    }
                    
                }
            })
        },
        //插入数据
        setConfig(obj){
            for(var i=0;i<this.setList.length;i++){
                if(obj.priorityTyep==this.setList[i].priorityTyep){
                    this.setList[i].limitDate = obj.limitDate
                }
            }
            console.log(this.setList)
        },
        //提交
        configInfo(){
            var that = this
            myHttp.addQsConfiguration({
                jsonString:JSON.stringify(this.setList)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('操作成功')
                    that.warnVis = false
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
    },
}
</script>

<style scoped>
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        overflow: auto;
        background: #fff;
        border-radius: 0.5vh;
        padding: 2vh;
    }
    .main-table{
        /* width: calc( 100% - 15vw ); */
        width: 100%;
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 8vh;
        /* border-bottom: 3px solid #f5f5f5; */
        border-top: 1vh solid #ecf0f5;
        border-bottom: 1vh solid #ecf0f5;
    }
    .build-bar span {
        margin-left: 30px;
        margin-right: 20px;
        white-space: nowrap;
        font-weight: bold;
    }
    .build-bar a {
        display: inline-block;
        white-space: nowrap;
        font-size: 17px;
    }
    .build-bar a p {
        display: inline-block;
        margin-left: 10px;
        margin-right: 40px;
    }
    .build-bar > .el-input {
        margin-left: 50px;
        width: 400px;
    }
    .build-bar > .el-button {
        margin-left: 20px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }
    .build-bar > .el-button + .el-button {
        margin-left: 800px;
    }
    .build-table {
        position: relative;
        width: 100%;
        /* margin: 0 auto; */
        height: calc( 100% - 14vh );
        overflow: auto;
    }
    .table-item{
        width: 100%;
        height: 22vh;
        position: relative;
        display: flex;
        padding: 1vh;
        border-bottom: 1vh solid #ecf0f5;
    }
    .table-item .item-l{
        width: 11vw;
        height: 100%;
        position: relative;
    }
    .table-item .item-r{
        width: 5vh;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vw;
    }
    .table-item .item-mid{
        width: calc( 50% - 15vw );
        height: 100%;
        position: relative;
        justify-content: flex-start;
        display: flex;
        flex-wrap: wrap;
        padding-left: 1vw;
    }
    .table-item .item-mid p{
        width: 100%;
        height: 3vh;
        position: relative;
        text-align: left;
        line-height: 3vh;
        color: #737477;
    }
    .el-button-group>.headCur{
        color: #fff;
        background: #17b2fe;
    }
    .head-type{
        color: #17b2fe;
        width: 98px;
        height: 40px;
    }
    .el-button-group>.headCur{
        color: #fff;
        background: #17b2fe;
    }

    .build-bar .on{
        background: #A4C7FD;
        color: #fff;
    }
    .cur{
      color: #FF0000 !important;
    }
</style>
<style>
    .qsList .el-tabs{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
    .qsList .el-tabs__header{
        margin: 0;
    }
    .qsList .el-tabs__item{
        width: 5vw;
    }
    .qsList .el-tabs__nav-scroll{
        padding-left: 20px;
    }
    .qsList .el-tabs__content{
        height: calc( 100% - 4vh );
    }
    .qsList .el-tab-pane{
        width: 100%;
        height: 100%;
        position: relative;
    }
    @import '../../assets/css/common.css'
</style>